"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceBrowserSelector = void 0;
const react_1 = __importStar(require("react"));
const resource_browser_1 = require("@squiz/resource-browser");
const InputContainer_1 = require("../InputContainer/InputContainer");
const Extensions_1 = require("../../../Extensions/Extensions");
const ResourceBrowserSelector = ({ modalTitle, allowedTypes, value, onChange, ...props }) => {
    const convertFormDataToResourceBrowserValue = (0, react_1.useCallback)((value) => {
        if (value?.matrixIdentifier && value?.matrixAssetId) {
            return {
                sourceId: value.matrixIdentifier,
                resourceId: value.matrixAssetId,
            };
        }
        else if (value?.damSystemIdentifier && value?.damObjectId) {
            return {
                sourceId: value.damSystemIdentifier,
                resourceId: value.damObjectId,
            };
        }
        return null;
    }, []);
    const handleResourceChange = (0, react_1.useCallback)((resource) => {
        // Clear out any key properties for clear resource use case
        let onChangeData = {
            ...value,
            matrixIdentifier: undefined,
            matrixAssetId: undefined,
            damSystemIdentifier: undefined,
            damObjectId: undefined,
            damSystemType: undefined,
            url: undefined,
        };
        if (resource?.source?.type === 'matrix') {
            onChangeData = {
                ...value,
                matrixIdentifier: resource?.source?.id,
                matrixAssetId: resource?.id,
                url: resource?.url,
                nodeType: Extensions_1.NodeName.AssetImage,
            };
        }
        else if (resource?.source?.type === 'dam') {
            onChangeData = {
                ...value,
                damSystemIdentifier: resource?.source?.id,
                damObjectId: resource?.id,
                damSystemType: (resource?.source).configuration.externalType,
                url: resource?.url,
                nodeType: Extensions_1.NodeName.DAMImage,
            };
        }
        onChange({
            target: {
                value: {
                    ...onChangeData,
                },
            },
        });
    }, []);
    return (react_1.default.createElement(InputContainer_1.InputContainer, { ...props },
        react_1.default.createElement(resource_browser_1.ResourceBrowser, { modalTitle: modalTitle, allowedTypes: allowedTypes, value: convertFormDataToResourceBrowserValue(value), onChange: handleResourceChange })));
};
exports.ResourceBrowserSelector = ResourceBrowserSelector;
